export const en = {
  physician: 'Physician',
  roleGroup: 'Role Group',
  frequency: 'Frequency',
  period: 'Period',
  chooseloc: 'Pick LOC',
  dischargeReason: 'Discharge Reason',
  facility: 'Facility Name',
  verifyPhysicianOrder: 'Physician giving orders',
  verifyFreqOrder: 'Frequency changes',
  verifyVerbalReceived: 'Date Verbal received',
  cancel: 'CANCEL',
  createDetails: 'CREATE DETAILS',
  modifyDetails: 'MODIFY DETAILS',
  orderVerifiedCheck: 'Order verified',
  modifyOrder: 'MODIFY ORDER',
  convoType: 'Conversation type',
  verifyOrderType: 'Type of order'
};
export default en;